import React from 'react';
import Background from './Background';
import Footer from './Footer';
import Header from './Header';

const Page = ({
  children,
} = {}) => (
  <div className="min-vh-100 d-flex flex-column">
    <Background />
    <Header />
    <div className="flex-fill">
      {children}
    </div>
    <Footer />
  </div>
);

export default Page;
